import React from 'react';
import { useHistory } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { FaCheck, FaTimes } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import Col from 'react-bootstrap/Col';
import { useForm } from 'react-hook-form';
import get from 'lodash/get';
import { useQMEByApptId } from './hooks';
import Loader from 'react-loader';
import { useMutation } from 'react-query';
import { chrApi } from '../../api/api';
import { toast } from 'react-toastify';

const initialStatePrimaryState = {
  claimNo: '',
  panelNo: '',
  wcabNo: '',
  eams: '',
  doi: '',
  injury: '',
};

function InjuryInformationForm(props) {
  const history = useHistory();
  const appointmentId = get(props, 'match.params.appointmentId');

  const { register, control, reset, handleSubmit, errors } = useForm({
    defaultValues: {
      injuries: {
        claimNo: '',
        panelNo: '',
        wcabNo: '',
        eams: '',
        doi: '',
        injury: '',
      },
    },
  });

  const { data, isLoading } = useQMEByApptId(appointmentId, (res) => {
    let { injuries = [] } = res;
    const primaryInjury = injuries.find((inj) => inj.isPrimary);
    reset({ injuries: primaryInjury ? primaryInjury : initialStatePrimaryState });
  });

  const qmeId = data?.id;

  const { mutate } = useMutation(
    (formData) => {
      return chrApi('put', `medical_evaluation/${qmeId}`, formData);
    },
    {
      mutationKey: 'updateQmeInjuryInfo',
      onSuccess: () => {
        toast.success('Injury Information Successfully Updated');
        sendBackToQME();
      },
    },
  );

  const sendBackToQME = () => {
    history.push(`/qme_appointment/${appointmentId}`);
  };

  function onSubmit(formData) {
    const { injuries = [], patientId, providerId, practiceId } = data;
    const primaryInjury = injuries.find((inj) => inj.isPrimary);
    let payload = { ...formData.injuries, patientId, providerId, practiceId, appointmentId, isPrimary: true };
    if (primaryInjury) {
      payload = { ...primaryInjury, ...payload };
    }
    mutate({ injuries: [payload] });
  }

  function handleOnCancel() {
    sendBackToQME();
  }

  if (isLoading) {
    return <Loader loaded={false} />;
  }

  return (
    <Container fluid>
      <p className={'h4 mb-3'}>QME-AME Injury Info</p>
      <Container fluid className={'bg-white p-3'}>
        <p className={'h5 mb-3'}>Primary Injury</p>
        <Row className={'mb-2'}>
          <Col xs={2}>
            <FormGroup controlId={`injuries.doi`}>
              <FormLabel>{'DOI'}</FormLabel>
              <FormControl isInvalid={errors?.injuries?.doi?.type} name={`injuries.doi`} type="text" control={control} defaultValue={''} ref={register({ required: true })} />
              <FormControl.Feedback type={'invalid'}>This field is required</FormControl.Feedback>
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup controlId={`injuries.injury`}>
              <FormLabel>{'Injury/Body Parts'}</FormLabel>
              <FormControl name={`injuries.injury`} type="text" control={control} defaultValue={''} ref={register({ required: false })} />
            </FormGroup>
          </Col>
        </Row>
        <Row className={'mb-2'}>
          <Col xs={2}>
            <FormGroup controlId={`injuries.claimNo`}>
              <FormLabel>{'Claim#'}</FormLabel>
              <FormControl name={`injuries.claimNo`} type="text" control={control} defaultValue={''} ref={register({ required: false })} />
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup controlId={`injuries.panelNo`}>
              <FormLabel>{'Panel#'}</FormLabel>
              <FormControl name={`injuries.panelNo`} type="text" control={control} defaultValue={''} ref={register({ required: false })} />
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup controlId={`injuries.wcabNo`}>
              <FormLabel>{'WCAB#'}</FormLabel>
              <FormControl name={`injuries.wcabNo`} type="text" control={control} defaultValue={''} ref={register({ required: false })} />
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup controlId={`injuries.eams`}>
              <FormLabel>{'EAMS'}</FormLabel>
              <FormControl name={`injuries.eams`} type="text" control={control} defaultValue={''} ref={register({ required: false })} />
            </FormGroup>
          </Col>
        </Row>
        <Row className={'my-3'}>
          <Col>
            <Button size={'sm'} onClick={handleSubmit(onSubmit)} className={'mr-2'} variant={'primary'}>
              <FaCheck className={'mr-1 mb-1'} />
              Save
            </Button>
            <Button onClick={handleOnCancel} size={'sm'} variant={'fff'}>
              <FaTimes className={'mr-1 mb-1'} />
              Cancel
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

InjuryInformationForm.propTypes = {};
InjuryInformationForm.defaultProps = {};

export default InjuryInformationForm;
